import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { KeycloakService } from '../../services/keycloak.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  constructor(
    private keycloakService: KeycloakService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.keycloakService.hasAdminRole()) {
      return true;
    }

    // User doesn't have ADMIN role - redirect to 403 page
    console.warn('Access denied: User does not have ADMIN role');
    this.router.navigate(['/access-denied']);
    return false;
  }
}

